import React, { useState, useEffect } from "react";

import { makeStyles } from "@material-ui/core/styles";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "components/CustomButtons/Button.js";
import DialogActions from "@material-ui/core/DialogActions";

// @material-ui/icons

import { TitleModalStyled, SubtitleModalStyled, styles } from "./styles";

// import styles from "assets/jss/material-dashboard-pro-react/modalStyle.js";
import { BLUE_RGB } from "utils/colorsTheme";
import { ConfigUnitGroup } from "components/ConfigUnitGroup/ConfigUnitGroup";
import { ModalV2 } from "components/Modal/ModalV2";
import { useDispatch, useSelector } from "react-redux";
import { CedisInput } from "./CedisInput";
import { Divider } from "@material-ui/core";
import { sendConfigUnitV2 } from "redux/actions/unitsSection/unitsAction";

const useStyles = makeStyles(styles);


const ModalConfig = ({
  isOpen,
  onCloseModal,
  item,
  title = "",
  config = {},
  dispenser=false,
  idUnit
}) => {

  const classes = useStyles();
  const [configState, setConfigState] = useState({ conf: {} });
  const dispatch = useDispatch()
  const { token } = useSelector(({ login }) => login)
  const handleChangeRow = (property, value) => {
    setConfigState((prevState) => {
      return { ...prevState, conf: { ...prevState.conf, [property]: value } };
    });
  };
  const handleSubmit = () => {
    const rawFactor = configState.conf?.factor;
    let factorValue = null;
    if (rawFactor != null && String(rawFactor).trim() !== "") {
      factorValue = rawFactor;
    }
    if (item) {
      const body = { id: item.id, conf: { ...configState.conf, factor: factorValue } };
      !dispenser 
        ? dispatch(sendConfigUnitV2(item.id, body)) 
        : dispatch(sendConfigUnitV2(item.id, body, false, true));
    }
    onCloseModal("configModal");
  };

  useEffect(() => {
    if (item) {
      setConfigState({ conf: { ...item.conf } });
    }
  }, [item]);
  return (
    <>
      <ModalV2
        open={isOpen}
        title={title}
        toRight
        onClose={() => onCloseModal()}
      >
        <DialogTitle
          id="classic-modal-slide-title"
          disableTypography
          className={classes.modalHeader}
        >
          <div>
            <TitleModalStyled color={BLUE_RGB} className={classes.modalTitle}>
              Unidad
            </TitleModalStyled>
            <SubtitleModalStyled>
              {item ? item[title] : "Unidad"}
            </SubtitleModalStyled>
          </div>
        </DialogTitle>
        <DialogContent
          id="modal-slide-description"
          className={classes.modalBody}
        >
          {
            !dispenser &&
            <>
              <CedisInput cedis={item?.unitCedisTransfer} />
              <Divider />
            </>
          }
          {config.length
            ? config.map((conf) => {
              if (conf.property === 'freeSales') return null;

              return <ConfigUnitGroup
                key={conf.id}
                config={conf.type}
                row={conf}
                unit={configState}
                onChangeRow={handleChangeRow}
              />;
            })
            : null}
        </DialogContent>
        <DialogActions
          className={classes.modalFooter + " " + classes.modalFooterCenter}
        >
          <Button onClick={() => onCloseModal("configModal")} color="danger">
            Salir
          </Button>
          <Button onClick={() => handleSubmit()} color="success">
            Guardar
          </Button>
        </DialogActions>
      </ModalV2>
    </>
  );
};

export default ModalConfig;
